export const phoneUrl = (info, phone) => {
  const { userMap } = info || {}
  const list = Object.keys(userMap) || []
  if (list.includes(phone)) {
    return `/customer/user/index/${phone}/${userMap[phone]}`
  }
  return ''
}
